import React, { Component } from 'react';
import {isNumber} from 'utils/IsNumber.js';
import Dropdown from 'react-dropdown';
import ConditionedComponent from 'components/ConditionedComponent.js';
import EffectParameterSlider from './EffectParameterSlider.js';
import {setContextualHelp} from "actions/index.js";
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { connect } from "react-redux";

class AlternateTuningEffectComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.props.effect.isEnabled();
    }

    render() {
        let notes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
        return (
            <div>
              <ConditionedComponent condition={this.isEnabled()}>
                {notes.map(
                    note =>
                        <NoteMapping
                          isLastNote={this.props.lastNotePlayed === note}
                          input={note}
                          effect={this.props.effect}/>)}
              </ConditionedComponent>
            </div>
        );
    }
}

class NoteMapping extends Component {

    constructor(props) {
        super(props);

        this.state = {
            value: this.getOutput()
        };
    }

    getOutput() {
        return this.props.effect.tuningMappings[this.props.input];
    }

    onUpdateOutput(output) {
        if (output === "") {
            this.props.effect.tuningMappings[this.props.input] = 0;
            this.setState({value: ""});
        } else if (output === "-") {
            this.props.effect.tuningMappings[this.props.input] = 0;
            this.setState({value: "-"});
        } else if (output === ".") {
            this.props.effect.tuningMappings[this.props.input] = 0;
            this.setState({value: "."});
        } else if (!isNumber(output)) {
            return;
        }

        try {
            let val = parseFloat(output);
            this.props.effect.tuningMappings[this.props.input] = val;
        } catch(e) {
        }

        this.setState({
            value: output
        });
    }

    render() {
        let className = this.props.isLastNote ? "note-mapping highlighted" : "note-mapping";
        return (
            <div className={className}>
              <label className="input-note">{this.props.input}:</label>
              <Input
                value={this.state.value}
                onChange={(event) => this.onUpdateOutput(event.target.value)}
                placeholder="Output Note"
                className="note-mapping-output"/>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        lastNotePlayed: state.keyboard.lastNotePlayed,
    };
};


const mapDispatchToProps = (dispatch, props) => {
    return {
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
}
 
export default connect(mapStateToProps, mapDispatchToProps)(AlternateTuningEffectComponent);
